var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 46.1 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M33.9 53.8v12.5s9.9 1.4 9.9-6.5c-.1 0-.4-7.7-9.9-6zM2.3 66.4V53.9c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.8-8.6 3.5M18.1 66.4V53.9c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.8-8.6 3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpd);
export default __webpack_public_path__ + "static/media/PPD.5108c29ca0e368ef283d2d365715bdae.svg";
export { ForwardRef as ReactComponent };